export const DEFAULT_LOCALE = "fa";
export const SECONDARY_LOCALE = "en";
export const LOCALE_COOKIE = "app_locale";
export const LOCALE_QUERY_PARAM = "locale";
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export type AppLocale = typeof DEFAULT_LOCALE | typeof SECONDARY_LOCALE;

export const isSecondaryLocaleEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_EN_LOCALE_ENABLED === "true";
